/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MetaformVersionType,
    MetaformVersionTypeFromJSON,
    MetaformVersionTypeFromJSONTyped,
    MetaformVersionTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MetaformVersion
 */
export interface MetaformVersion {
    /**
     * 
     * @type {string}
     * @memberof MetaformVersion
     */
    readonly id?: string;
    /**
     * 
     * @type {MetaformVersionType}
     * @memberof MetaformVersion
     */
    type: MetaformVersionType;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof MetaformVersion
     */
    data: { [key: string]: object; };
    /**
     * ID of creator
     * @type {string}
     * @memberof MetaformVersion
     */
    readonly creatorId?: string;
    /**
     * Created date
     * @type {Date}
     * @memberof MetaformVersion
     */
    readonly createdAt?: Date;
    /**
     * Id of last modifier
     * @type {string}
     * @memberof MetaformVersion
     */
    readonly lastModifierId?: string;
    /**
     * Date modified
     * @type {Date}
     * @memberof MetaformVersion
     */
    readonly modifiedAt?: Date;
}

export function MetaformVersionFromJSON(json: any): MetaformVersion {
    return MetaformVersionFromJSONTyped(json, false);
}

export function MetaformVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetaformVersion {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': MetaformVersionTypeFromJSON(json['type']),
        'data': json['data'],
        'creatorId': !exists(json, 'creatorId') ? undefined : json['creatorId'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'lastModifierId': !exists(json, 'lastModifierId') ? undefined : json['lastModifierId'],
        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (new Date(json['modifiedAt'])),
    };
}

export function MetaformVersionToJSON(value?: MetaformVersion | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': MetaformVersionTypeToJSON(value.type),
        'data': value.data,
    };
}


